export const POST_SALES_APARTMENT = "POST_SALES_APARTMENT";
